import { PageName } from 'generated/types'
import { FlowRoute } from 'utils/FlowProvider/types'

export const PageToRoute = {
  [PageName.ABOUT_PORTFOLIO]: FlowRoute.AboutPortfolio,
  [PageName.BANK_LINK_SUCCESS]: FlowRoute.BankLinkSuccess,
  [PageName.CHOOSE_FUNDING_SOURCE]: FlowRoute.ChooseFundingSource,
  [PageName.CONTACT_INFO]: FlowRoute.ContactInfo,
  [PageName.DIRECT_BANK_INTEGRATION]: FlowRoute.DirectBankIntegration,
  [PageName.DIRECT_BANK_INTEGRATION_REDIRECT]: FlowRoute.DirectBankIntegrationRedirect,
  [PageName.FUNDING]: FlowRoute.Funding,
  [PageName.INSTITUTIONS]: FlowRoute.Institutions,
  [PageName.INVEST_INTERSTITIAL]: FlowRoute.InvestInterstitial,
  [PageName.INVESTOR_QUESTIONS]: FlowRoute.InvestorQuestions,
  [PageName.MANUAL_FUNDING_SOURCE]: FlowRoute.ManualFundingSource,
  [PageName.MFA_SET_UP]: FlowRoute.MFASetup,
  [PageName.ONE_TIME_INVESTMENT]: FlowRoute.OneTimeInvestment,
  [PageName.PERSONAL_INFO]: FlowRoute.PersonalInfo,
  [PageName.PLAID_LINK_REDIRECT]: FlowRoute.PlaidLinkRedirect,
  [PageName.PREVIEW_PORTFOLIO]: FlowRoute.PreviewPortfolio,
  [PageName.PRICING_INTERSTITIAL]: FlowRoute.PricingInterstitial,
  [PageName.PRODUCT_ONBOARDING]: FlowRoute.ProductOnboarding,
  [PageName.RECURRING_INVESTMENT]: FlowRoute.RecurringInvestment,
  [PageName.ROUND_UPS_FUNDING]: FlowRoute.RoundUpsFunding,
  [PageName.ROUND_UPS_INTERSTITIAL]: FlowRoute.RoundUpsInterstitial,
  [PageName.ROUND_UPS_PAST]: FlowRoute.RoundUpsPast,
  [PageName.ROUND_UPS_SET_UP]: FlowRoute.RoundUpsSetup,
  [PageName.SECOND_CHANCE_INSTITUTIONS]: FlowRoute.Institutions,
  [PageName.SIGNUP]: FlowRoute.Signup,
  [PageName.SSN]: FlowRoute.SSN,
  [PageName.SUCCESS]: FlowRoute.Success,
  [PageName.SUITABILITY_QUESTIONS]: FlowRoute.SuitabilityQuestions,
}
